import React from 'react'
import logoIcon from '../../assets/logo-icon.png'
import { Link } from 'react-router-dom'

function Logo() {
  return (
    <Link to='/' className='block'>
      <div className='flex items-center gap-2'>
        <img src={logoIcon} alt="logo" className='w-[50px] md:w-[58px]' />
        <h4 className='text-2xl md:text-3xl font-black text-[#7c6a7f]'>the<span className='text-[#651f65]'>CITI</span>soft</h4>
      </div>
      <p className='hidden md:block text-xs font-semibold'>We provide insights and values to our customer</p>
    </Link>
  )
}

export default Logo